import axios from "axios";
import type { ResolveInviteSlugResponse } from "@smartwiz/shared-types";

import { backend_url } from "@/constants";
import { AXIOS_CONFIG } from "../api";

/**
 * Resolve a vanity slug or business_id to business identity and frontend mode.
 *
 * @param slug - Vanity slug (case-insensitive) or raw business_id
 * @returns Resolved business identity for invite routing
 */
export async function resolveInviteSlug(
  slug: string
): Promise<ResolveInviteSlugResponse> {
  const response = await axios.get<{ content: ResolveInviteSlugResponse }>(
    `${backend_url}/api/business/resolve-invite/${encodeURIComponent(slug)}/`,
    {
      ...AXIOS_CONFIG,
    }
  );

  return response.data.content;
}
